import React from "react";

export const DataIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none">
      <path
        d="M17.6 17.6005C17.6 20.0305 13.6601 22.0005 8.8 22.0005C3.93989 22.0005 0 20.0305 0 17.6005V13.1719C0.552431 13.8501 1.33645 14.4137 2.20851 14.8496C3.93804 15.7144 6.26964 16.2255 8.8 16.2255C11.3303 16.2255 13.662 15.7144 15.3915 14.8496C16.2636 14.4137 17.0476 13.8501 17.6 13.1719V17.6005Z"
        fill="#E0E0E0"
      />
      <path
        d="M8.8 9.62492C11.3303 9.62492 13.662 9.11386 15.3915 8.2491C16.2636 7.81306 17.0476 7.24957 17.6 6.57129V10.9999C17.6 11.5499 15.6357 12.7501 14.6535 13.3733C13.1981 14.101 11.1298 14.5749 8.8 14.5749C6.47026 14.5749 4.40185 14.101 2.94642 13.3733C1.65 12.7251 0 11.5499 0 10.9999V6.57129C0.552431 7.24957 1.33645 7.81306 2.20851 8.2491C3.93804 9.11386 6.26964 9.62492 8.8 9.62492Z"
        fill="#E0E0E0"
      />
      <path
        d="M14.6533 6.77337C13.1979 7.50109 11.1296 7.975 8.79978 7.975C6.47003 7.975 4.40162 7.50109 2.94619 6.77337C2.38 6.55156 1.10678 5.84641 0.221426 4.70728C0.0707703 4.51344 0.00611211 4.26638 0.0436441 4.02378C0.0688891 3.86066 0.104056 3.69265 0.149134 3.58849C0.910741 1.54609 4.49416 0 8.79978 0C13.1054 0 16.6888 1.54609 17.4504 3.58849C17.4955 3.69265 17.5307 3.86066 17.5559 4.02378C17.5934 4.26638 17.5288 4.51344 17.3781 4.70728C16.4927 5.84641 15.2196 6.55156 14.6533 6.77337Z"
        fill="#E0E0E0"
      />
    </svg>
  );
};
